import $ from 'jquery';
import fitvids from 'fitvids';
import GroupedContent from 'grouped-content';

export default class Rte {
  constructor({ el }) {
    this.$el = $(el);
    this.setupTabs();
    this._bindEvents();

    fitvids('.rte', {
      customSelector: 'iframe',
      ignore: "[data-shop='embeds.myshopify.com']",
    });

    $('select', this.$el).each((index, select) => {
      if (!$(select).parent('.select-wrapper').length) {
        $(select).wrap('<div class="select-wrapper" />').parent().prepend("<span class='selected-text'></span>");
      }
      this.updateOption(null, select);
    });
  }

  _bindEvents() {
    this.events = [
      $('.select-wrapper select', this.$el).on('change', this.updateOption),
    ];
  }

  setupTabs() {
    this.groupedContent = new GroupedContent(this.$el.get(0), { layout: 'tabs', intelliparse: false });
  }

  updateOption(e, selector) {
    const select = e ? $(e.target) : $(selector);

    const newOption = select.find('option:selected').text();
    select.siblings('.selected-text').text(newOption);
  }
}
